// extracted by mini-css-extract-plugin
module.exports = {"infoModal":"NoteInfoModal_infoModal__kcNKl","okBtn":"NoteInfoModal_okBtn__18MQj"};